import type { ComponentSchema } from '../../../../../schema-types'
import { SECTION_STYLE_FIELDS } from './_fields'

/**
 * Khelaghor categories: `v1` is the categories page (each top-level category with its sub-categories as picture
 * tiles); `pills` is the home row of pastel category pills (picture or icon and name), scrollable on phones. Keys of
 * `v1` match the shared categories section.
 */
export const schema: ComponentSchema = {
  type: 'categories',
  label: 'Categories',
  description: 'All categories as picture tiles (categories page), or a row of pastel category pills (home).',
  supportedPages: ['categories', 'home'],
  variants: [
    {
      id: 'v1',
      label: 'All categories (page)',
      fields: [
        { key: 'title', label: 'Title', type: 'string', default: 'Shop by category' },
        { key: 'subtitle', label: 'Subtitle', type: 'string', default: 'Toys, baby care, school and more, sorted for you.' },
        {
          key: 'columns',
          label: 'Tiles per row (desktop)',
          type: 'select',
          options: [
            { label: '4', value: 2 },
            { label: '5', value: 3 },
            { label: '6', value: 4 },
          ],
          default: 4,
        },
        { key: 'emptyText', label: 'Text when there are no categories', type: 'string', default: 'No categories yet.' },
      ],
    },
    {
      id: 'pills',
      label: 'Pastel pills',
      fields: [
        {
          key: 'pills',
          label: 'Pills',
          type: 'array',
          help: 'Empty = the store’s top-level categories.',
          itemSchema: [
            { key: 'categoryId', label: 'Category', type: 'category-select', help: 'Sets the link, name and picture unless filled below.' },
            { key: 'label', label: 'Name', type: 'string' },
            { key: 'image', label: 'Picture', type: 'image', help: 'Small and square. Empty = the category picture, else an icon.' },
            { key: 'link', label: 'Link', type: 'string', placeholder: '/category/…' },
          ],
          default: [],
        },
        { key: 'limit', label: 'Pills shown (automatic)', type: 'number', default: 6 },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
}
